export default "__VITE_ASSET__CljaXnxF__"